// extracted by mini-css-extract-plugin
export default {"overlay":"zH-z","bodyOpen":"AH-z","content":"BH-z","header":"CH-z","close":"DH-z","closeNoHeading":"EH-z"};